<template>
<div>
  <div class="row">
    <h3 class="col-4 page-heading ">Plans</h3>
    <div class="col-8 text-right">
      <button type="button" class="btn btn-default selectPlanFrequency" :class="{'active': planFrequency==='monthly'}" @click="changePlanFrequency('monthly')">Monthly</button>
      <button type="button" class="btn btn-default selectPlanFrequency" :class="{'active': planFrequency==='yearly'}" @click="changePlanFrequency('yearly')">Anually</button>
    </div>
  </div>
	<div class="card-deck mb-3 text-center">
    <template v-for="item in plans">
      <div class="card mb-4 shadow-sm" :class="{'card-active': item.isActive === true}">
        <div class="card-header" :class="{'card-active': item.isActive === true}">
          <h4 class="my-0 font-weight-normal">{{item.type}}</h4>
        </div>
        <div class="card-body">
          <div>   
            <h1 class="card-title plan-desc">{{item.description}}</h1>
            <h1 class="card-title pricing-card-title">${{item.amount}}
              <small class="text-muted">/
                <template v-if="planFrequency === 'monthly'">mo</template>
                <template v-else-if="planFrequency === 'yearly'">yly</template>
              </small>
            </h1>
          </div>
          <button type="button" class="btn btn-default choose-plan" :class="{'card-active': item.isActive === true}" @click="choosePlan(item)">Choose This Plan</button>
        </div>
      </div>
    </template>
	</div>
  <div class="signup-footer" v-if="$route.fullPath != '/newprofile/company/plans'">
    <button class="btn btn-primary btn-block btn-lg" @click="goToBilling">Next</button>
  </div>
</div>
</template>

<script>

export default {
  data () {
    return {
      plansObject: {
        monthly: [
          {
            type: 'Beginner',
            description: 'Free',
            amount: 0,
            isActive: false
          },
          {
            type: 'Intermediate',
            description: 'Plan A',
            amount: 9,
            isActive: true
          },
          {
            type: 'Advanced',
            description: 'Plan B',
            amount: 19,
            isActive: false
          }
        ],
        yearly: [
          {
            type: 'Beginner',
            description: 'Free',
            amount: 0,
            isActive: false
          },
          {
            type: 'Intermediate',
            description: 'Plan A',
            amount: 69,
            isActive: true
          },
          {
            type: 'Advanced',
            description: 'Plan B',
            amount: 99,
            isActive: false
          }
        ]
      },
      plans: {},
      planFrequency: 'monthly'
    }
  },
  mounted: function () {
    this.plans = this.plansObject.monthly
  },
  methods: {
    changePlanFrequency (frequency) {
      if (frequency === 'monthly') {
        this.plans = this.plansObject.monthly
        this.planFrequency = 'monthly'
      } else {
        this.plans = this.plansObject.yearly
        this.planFrequency = 'yearly'
      }
    },
    choosePlan (item) {
      this.plans.forEach(element => {
        element.isActive = false
        if (element.type === item.type) {
          element.isActive = true
        }
      })
    },
    goToBilling () {
      this.$router.push('billing')
    }
  }
}
</script>
<style scoped>
.btn {
  margin: 5px;
}
.card-deck {
  margin-top: 20px;
}

.card {
  border: 1px solid rgba(0, 0, 0, 0.25);
  border-radius: 0.5rem;
  height: calc(80vh - 150px);
  margin-right: 40px;

}

.card-header {
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}

.btn-default {
  border: 0.5px solid;
  background: grey;
  color: #fff;
}

.plan-desc {
  text-transform: uppercase;
}

.next {
  text-transform: uppercase;
  margin-top: 60vh;
}

.card:hover{
  border-color: #47b784;
}

.card:hover .btn {
  background-color: #47b784;
  color: #fff;
}

.card:hover .card-header {
  background-color: #47b784;
  color: #fff;
}

.card-active .card-header {
  background-color: #47b784;
  color: #fff;
}

.card-active .btn {
  background-color: #47b784;
  color: #fff;
}

.card-active .card {
  border-color: #47b784;
}

.selectPlanFrequency:hover, .active{
  background-color: #47b784;
  color: #fff;
}

/* .choose-plan {
  position: absolute;
  right: 80px;
  bottom: 0;
  margin-bottom: 10px;
} */
.card-body {
    display : flex;
    flex-direction: column;
   align-items : center;
   justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/views/Plans.vue